import { useEffect, useState } from 'react';
import { Icon, IconButton } from '@mui/material';
import { getPatientImage } from 'api/routes';

export default function PrescriptionButton({ patient, onOpen }) {
    const [files, setFiles] = useState(null);
    const marker = patient.isImage;
    const hasMarker = marker !== undefined;
    const hasImage = hasMarker
        ? marker !== null && marker !== false && marker !== 0 && marker !== '0' && marker !== ''
        : Array.isArray(files) && files.length > 0;
    useEffect(() => {
        let active = true;
        setFiles(null);
        if (!hasMarker) {
            getPatientImage(patient.patientId, (isOk, data) => {
                if (active) setFiles(isOk && Array.isArray(data) ? data.filter(file => file.fileSrc) : []);
            });
        }
        return () => { active = false; };
    }, [patient.patientId, hasMarker]);
    if (!hasImage) return null;
    return <IconButton size="small" title="نمایش نسخه" aria-label="نمایش نسخه"
        onClick={(event) => {
            event.stopPropagation();
            onOpen(files ? { ...patient, prescriptionFiles: files } : patient);
        }}>
        <Icon sx={{ color: '#0072a7' }}>image</Icon>
    </IconButton>;
}
